import React from 'react';

export const QueuedSample = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.89469 6.24069L6.183 4.92018H4.49065C4.1961 4.92018 3.95732 5.15896 3.95732 5.45351L3.95732 8.38334C3.95733 8.82517 3.59915 9.18334 3.15733 9.18334C2.7155 9.18334 2.35732 8.82517 2.35732 8.38334L2.35732 5.45352C2.35732 4.27531 3.31245 3.32018 4.49065 3.32018L6.16982 3.32018L6.16751 3.26602L4.90884 2.03882C4.59249 1.73038 4.58608 1.22388 4.89452 0.907536C5.20296 0.591187 5.70945 0.584776 6.0258 0.893216L8.21498 3.02767C8.79508 3.59327 8.8067 4.52209 8.24092 5.10201L6.03994 7.35801C5.73141 7.67426 5.22491 7.68051 4.90866 7.37197C4.59241 7.06344 4.58615 6.55694 4.89469 6.24069Z"
          // fill="#DA2E9A"
          fill="currentColor"
        />
        <path
          d="M13.4578 7.64816C13.4578 7.20634 13.0996 6.84816 12.6578 6.84816H8.65779L8.576 6.85229C8.17259 6.89326 7.85779 7.23395 7.85779 7.64816C7.85779 8.08999 8.21597 8.44816 8.65779 8.44816H12.6578L12.7396 8.44403C13.143 8.40307 13.4578 8.06238 13.4578 7.64816Z"
          fill="currentColor"
        />
        <path
          d="M12.8483 10.1815C13.2901 10.1815 13.6483 10.5397 13.6483 10.9815C13.6483 11.3957 13.3335 11.7364 12.9301 11.7774L12.8483 11.7815H3.13398C2.69216 11.7815 2.33398 11.4233 2.33398 10.9815C2.33398 10.5673 2.64878 10.2266 3.05219 10.1856L3.13398 10.1815H12.8483Z"
          fill="currentColor"
        />
        <path
          d="M12.8483 13.5148C13.2901 13.5148 13.6483 13.873 13.6483 14.3148C13.6483 14.729 13.3335 15.0697 12.9301 15.1107L12.8483 15.1148H3.13398C2.69216 15.1148 2.33398 14.7567 2.33398 14.3148C2.33398 13.9006 2.64878 13.5599 3.05219 13.519L3.13398 13.5148H12.8483Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};
